// extracted by mini-css-extract-plugin
export default {"button":"Settings_button__JTVOZ","icon":"Settings_icon__EHR-n"};